import { combineSlices, configureStore } from "@reduxjs/toolkit";
import { candidateSlice } from "./features/candidate/candidate-slice";
import { noteSlice } from "./features/note/note-slice";
import { procedureSlice } from "./features/procedure/procedure-slice";

const rootReducer = combineSlices(candidateSlice, noteSlice, procedureSlice);

export const store = configureStore({
    reducer: rootReducer
});